import { parseDomainUrl } from './parse-domain-url.js'

export function firstDomainUrl(payload: unknown): string | undefined {
  const direct = parseDomainUrl(payload)
  if (direct) return direct
  if (!payload || typeof payload !== 'object') return undefined
  const domains = (payload as Record<string, unknown>).domains
  return Array.isArray(domains)
    ? domains.map(parseDomainUrl).find((domain): domain is string => Boolean(domain))
    : undefined
}
